export const EmailIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.8446 9.77056L12.9211 12.1247C12.2953 12.5002 11.5135 12.5002 10.8877 12.1247L6.96415 9.77056M7.95219 19.651H15.8566C18.0393 19.651 19.8088 17.8816 19.8088 15.6988V9.77056C19.8088 7.58782 18.0393 5.81836 15.8566 5.81836H7.95219C5.76946 5.81836 4 7.58782 4 9.77056V15.6988C4 17.8816 5.76946 19.651 7.95219 19.651Z"
        stroke="#222530"
        strokeWidth="1.18566"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
